/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { FeatureConfig } from 'app/config/feature';

import { type UpgradeDetail, CheckResult, CmoDetailAtomState, Progress } from './upgrade.const';

enum Icon {
    loading = 'loading',
    succeed = 'status-succeed',
    failed = 'status-failed'
}

export enum CheckResultIcon {
    NotCheck = '#app-icon-icon-cloud',
    Checking = '#icon-loading',
    Successed = '#icon-status-succeed',
    Failed = '#icon-status-failed',
    Skipped = '#app-icon-warning'
}

export enum StatusIcon {
    Upgrading = '#app-icon-upgrade-ing',
    Fail = '#app-icon-upgrade-failed',
    Suc = '#app-icon-upgrade-suc'
}

enum Color {
    succeed = '#3DCCA6',
    failed = '#FF4C4C',
    checking = '#4D84ff'
}

export enum LicenseError {
    noLicense = 50334237
}

@Injectable()
export class UpgradeStrService {
    get = this.i18nService.get;

    i18n = {
        targetVersionTip: this.get('system.upgrade_task_start_targetVersion_valid', [...this.getTargetTip()]),
        targetVersionInvalidTip: this.get('common.formatRequire_error_validation',
            [this.get('system.upgrade_task_start_targetVersion_lab')]),
        upgrade: this.get('common.upgrade_label'),
        UpgradeMode: this.get('system.upgrade_task_start_upgradeMode_lab'),
        currentVersion: this.get('system.upgrade_task_start_currentVersion_lab'),
        targetVersion: this.get('system.upgrade_task_start_targetVersion_lab'),
        hotPatch: this.get('system.upgrade_task_start_upgradeMode_hotPatch_lab'),
        upgradeBtn: this.get('common.upgrade_label'),
        closeBtn: this.get('common.close_button'),
        cancelBtn: this.get('common.cancel_button'),
        uploadsuc: this.get('settings.licenseManage_term_uploadSucc_label'),
        uploading: this.get('common.uploading_lab'),
        upgradingTip: this.get('system.upgrade_task_systemUpgrading_lab'),
        uploadFailedMsg: this.get('common.rest_fail_label', [this.get('rest.uploadPatch_msg')]),
        sysUploadFailedMsg: this.get('common.rest_fail_label', [this.get('common.upload_button')]),
        upgradeTitle: this.get('common.upgrade_label'),
        total: this.get('home.alarm_term_total_lab'),
        sucCount: this.get('common.downloadsuccess_label'),
        failedCount: this.get('common.downloadFailed_label'),
        ignoreCount: this.get('system.upgrade_term_ignore_lab'),
        exit: this.get('system.upgrade_task_exit_btn'),
        exitTitle: this.get('system.upgrade_task_exit_title'),
        exitInfoTitle: this.get('system.upgrade_task_exitUpgradePage_title'),
        exitContent: this.get('system.otaUpgrade_term_quitUgrade_msg'),
        exitInfo: this.get('system.upgrade_task_exit_info'),
        reTry: this.get('common.retry_button'),
        cancle: this.get('common.cancel_button'),
        progress: this.get('system.upgrade_term_progress_lab'),
        checkSuccessed: this.get('common.downloadsuccess_label'),
        checkFailed: this.get('common.downloadFailed_label'),
        prechecking: this.get('system.upgrade_term_progress_prechecking_lab'),
        upgrading: this.get('system.upgrade_term_progress_installing_lab'),
        Verifying: this.get('system.upgrade_term_progress_verifying_lab'),
        precheckFailed: this.get('system.upgrade_term_progress_prechecking_fail_lab'),
        precheckSuc: this.get('system.upgrade_term_progress_prechecking_succ_lab'),
        upgradeFailed: this.get('system.upgrade_term_progress_installing_fail_lab'),
        upgradeSuc: this.get('system.upgrade_term_progress_installing_succ_lab'),
        /**
         * 升级成功，验证失败
         */
        verifyFailed: this.get('system.upgrade_term_progress_verifyFailUpgradeSuccess_lab'),
        verifySuc: this.get('system.upgrade_term_progress_verifying_succ_lab'),
        notcheck: this.get('system.upgrade_term_taskStatus_notcheck_lab'),
        checking: this.get('system.upgrade_term_taskStatus_checking_lab'),
        notInstall: this.get('system.upgrade_term_taskStatus_notInstall_lab'),
        inStalling: this.get('system.upgrade_term_taskStatus_installing_lab'),
        warningTip: this.get('system.upgrade_task_systemUpgrading_lab'),
        finishBtn: this.get('common.finish_btn'),
        systemUpgrade: this.get('system.upgrade_task_start_upgradeMode_system_lab'), // '系统升级'
        systemUpgradeMode: this.get('system.upgrade_task_start_upgradeWay_lab'), // 系统升级方式 -> 升级方式
        rapidUpgrade: this.get('system.upgrade_task_start_upgradeWay_quick_value'), // 快速升级
        systemUpgradeModeTip: this.get('system.upgrade_task_start_upgradeWay_tip'), // 当前只支持快速升级，其余方式请使用工具升级。
        preUpGradeCheck: this.get('system.upgrade_task_start_precheck_lab'), // 升级前评估
        updateEvalScript: this.get('system.upgrade_task_start_script_lab'), // 评估脚本
        update: this.get('system.upgrade_task_start_script_upgrade_value'), // 更新
        notUpdate: this.get('system.upgrade_task_start_script_NotUpgrade_value'), // 不更新
        evaluateBtn: this.get('system.upgrade_task_start_check_btn'), // 评估
        noDataTip: this.get('common.result_nodata_tip'),
        skip: this.get('common.ignored_btn'), // 忽略
        skipped: this.get('system.upgrade_task_view_ignored_lab'), // 已忽略
        rollBacking: this.get('system.upgrade_task_start_upgradeState_rollbacking'), // 回滚中 -> 正在回滚
        rollBackFailed: this.get('system.upgrade_task_start_upgradeState_rollbackFail'),
        rollBackSuc: this.get('system.upgrade_task_start_upgradeState_rollbackSuccess'), // 回滚成功
        rollback: this.get('common.rollback_button1'), // 回滚
        beforeUpgrade: this.get('system.upgrade_task_start_beforeUpgrade_info_lab'), // 升级前，必须先完成升级前评估和备份。
        detail: this.get('system.upgrade_task_view_detail_btn'), // 详情
        failDetail: this.get('system.upgrade_task_view_failDetail_btn'), // 失败详情
        upgradedStateSuccess: this.get('system.upgrade_task_start_upgradedState_checkSuccess'),
        continUpgrade: this.get('system.upgrade_task_view_continUpgrade_btn'), // 继续
        // 快速升级中
        sysUpgrading: this.get('system.upgrade_task_start_upgradeState_upgrading'),
        sysUpgradeSuc: this.get('system.upgrade_task_start_upgradeState_upgradSuccess'),
        sysUpgradePromptSuc: this.get('system.upgrade_task_start_upgradSuccess_info'),
        // sysUpgradeFail: this.get('system.upgrade_task_start_upgradeState_upgradFail'),
        sysUpgradeFail: this.get('system.upgrade_task_start_upgradeState_upgradFail'),
        sysUpgradePause: this.get('system.upgrade_task_start_upgradeState_upgradPause'),
        fail: this.get('common.downloadFailed_label'), // 失败
        complete: this.get('common.EnumDefine_RUNNING_STATUS_E_JOB_COMPLETED'), // 完成
        // 成功
        success: this.get('common.downloadsuccess_label'),
        // 失败
        failed: this.get('common.downloadFailed_label'),
        // 升级过程中，DeviceManager界面会自动断开，请稍后重新登录。
        upgrademsg: this.get('system.upgrade_task_start_DMmodeUpgrade_confirm_msg'),
        upgradeStateChecking: this.get('system.upgrade_task_start_upgradeState_checking'), // 升级前检查中
        upgradeStateCheckFail: this.get('system.upgrade_task_start_upgradeState_checkFail'), // 升级前检查失败
        upgradeStateCheckSuccess: this.get('system.upgrade_task_start_upgradeState_preCheckSuccess'), // 升级前检查成功
        hotPatchTitle: this.get('system.upgrade_task_view_upgradeMode_hotPatch_title'), // 热补丁升级
        quickTitle: this.get('system.upgrade_task_view_upgradeMode_quick_title'), // 快速升级
        xistRiskInfo: this.get('system.upgrade_task_view_existRisk_info'), // 当前仍有风险项，请及时处理
        retryButton: this.get('common.retry_button'),
        sysPrecheckingTip: this.get('system.upgrade_task_view_noRefresh_prechecking_info'),
        sysUpgradingTip: this.get('system.upgrade_task_view_noRefresh_upgrading_info'),
        sysRollbackingTip: this.get('system.upgrade_task_view_noRefresh_rollbacking_info'),
        sysVerifyingTip: this.get('system.upgrade_task_view_noRefresh_checking_info'),
        distributePack: this.get('system.upgrade_task_start_distributePack_info'),
        exportLink: this.get('system.exportData_term_export_link'), // 导出
        backupLab: this.get('system.upgrade_task_start_backup_lab'), // 备份
        exportConfigInfoLab: this.get('system.upgrade_task_start_exportConfigInfo_lab'), // 导出配置信息
        // 建议
        exportConfigInfoDescInfo: this.get('system.upgrade_task_start_exportConfigInfo_desc_info'),
        // 系统正在回滚，不推荐配置业务。
        rollbackTip: this.get('system.upgrade_task_systemRollBacking_lab'),
        // 提示
        eventLevelInfo: this.get('common.EnumDefine_EVENT_LEVEL_E_INFO'),
        upgradingInfo: this.get('system.upgrade_task_view_upgrading_info'),
        // 更新检查项组件包
        upgradeCheckFile: this.get('system.upgrade_task_upgradeCheck_lab'),
        // 检查项组件包
        checkFileLab: this.get('system.upgrade_task_checkFile_lab'),
        // 热补丁升级
        hotpatchInUpgrade: this.get('system.upgrade_task_upgradeHotPatchSameTime_lab'),
        // 补丁包
        hotpatchPackage: this.get('system.upgrade_task_softPackage_lab'),
        // 启用后，系统将同时进行热补丁升级。
        hotpatchSameTimeTip: this.get('system.upgrade_task_upgradeHotPatchSameTime_tip'),
        sysUpgradeUploadTip: this.get('system.upgrade_task_start_selectUpgradePackage_lab'),
        hotpatchUploadTip: this.get('system.upgrade_task_start_selecthotPatch_lab'),
        //  是
        updateLabel: this.get('common.term_yes_label'),
        // 否
        notUpdateLabel: this.get('common.term_No_label'),
        // 升级包
        upgradePackage: this.get('system.upgrade_task_start_UpgradeFile_lab'),
        // 升级包版本
        upgradePackageVersion: this.get('system.upgrade_task_upgradePackageVersion_lab'),
        // 补丁包版本
        patchVersion: this.get('system.upgrade_task_patchVersion_lab'),
        // 升级确认
        upgradeTaskConfirm: this.get('system.upgrade_task_confirm_title'),
        // 升级确认高危提示内容
        targetVersionWrong: this.get('system.upgrade_task_targetVersionWrong_confirm_msg'),
        // License
        licenseLab: this.get('system.upgrade_task_license_lab'),
        // 配置数据库
        configurationDatabaseLab: this.get('system.upgrade_task_configurationDatabase_lab'),
        backupInfoLab: this.get('system.upgrade_task_backup_info_lab'),
        backupInfoWithoutLicense: this.get('system.upgrade_task_backup_PassThroughMode_info_lab'),
        // 已完成备份
        finishBackupLab: this.get('system.upgrade_task_finishBackup_lab'),
        // License文件不存在，配置数据库已完成备份
        finishDatabaseBackupLab: this.get('system.upgrade_task_finishDatabaseBackup_lab'),
        // 重新备份
        backupAgainBtn: this.get('system.upgrade_task_backupAgain_btn'),
        // 请先完成升级前评估
        beforeUpgradeCheck: this.get('system.upgrade_task_start_beforeUpgradeCheck_info_lab'),
        hotPatchDes: this.get('system.upgrade_task_hotPatch_desc'),
        sysUpgradeDes: this.get('system.upgrade_task_systemUpgrade_desc'),
        previousBtn: this.get('common.previous_button'),
        nextBtn: this.get('common.next_button'),
        hotpachTitle: this.get('system.upgrade_task_HotPatch_title'),
        systemUpgradeTitle: this.get('system.upgrade_task_systemUpgrade_title'),
        /**
         * 请先上传升级包。
         */
        uploadUpgradePackageTip: this.get('system.upgrade_task_uploadUpgradePackage_err_tip'),
        /**
         * 请先上传升级包和补丁包。
         */
        uploadUpgradeandHotPackageTip: this.get('system.upgrade_task_uploadUpgradeandHotPackage_err_tip'),
        detailTitle: this.get('monitor.task_viewDetail_title_lable'),
        /**
         * 分发包失败
         */
        distFailTip: this.get('system.upgrade_task_start_distributePackFail_info'),
        /**
         * 查看详情
         */
        clickShowDetail: this.get('system.upgrade_task_start_viewDetail_info'),
        /**
         * 句号
         */
        period: this.get('common.Punctuation_preiod'),
        /**
         * 检查项组件包更新中
         */
        checkFileUpgrading: this.get('settings.upgrade_task_checkingFileUpdate_info'),
        /**
         * 检查项组件包更新成功
         */
        checkFileUpgradeSuc: this.get('settings.upgrade_task_checkFileUpdateSuccess_info'),
        /**
         * 检查项组件包更新失败，请联系技术工程师。
         */
        checkFileUpgradeFailed: this.get('settings.upgrade_task_checkFileUpdateFailContactEngineer_info'),
        /**
         * 升级前评估失败
         */
        evaluateFailed: this.get('settings.upgrade_task_pre-upgradeEvaluationFail_info'),
        /**
         * 升级前评估成功
         */
        evaluateSuccess: this.get('settings.upgrade_task_pre-upgradeEvaluationSuccess_info'),
        /**
         * 升级前评估中
         */
        evaluating: this.get('settings.upgrade_task_pre-upgradeEvaluation_info'),
        /**
         * 等待分发包
         */
        distributeWaiting: this.get('settings.upgrade_task_waitDistributePack_info'),
        /**
         * 分发包中
         */
        distributePackage: this.get('settings.upgrade_task_distributePack_info'),
        /**
         * 分发包成功
         */
        distributeSuccess: this.get('settings.upgrade_task_distributePackSuccess_info'),
        /**
         * 分发包失败
         */
        distributeFail: this.get('settings.upgrade_task_distributePackFail_info'),
        /**
         * 执行升级失败
         */
        executeUpgradeFail: this.get('common.rest_fail_label', [this.get('rest.execute_installPatch_msg')]),
        /**
         * 分发包中，请不要关闭或刷新浏览器。
         */
        distributingInfo: this.get('system.upgrade_task_view_noRefresh_distributingPack_info'),
        /**
         * 请不要关闭或刷新浏览器。
         */
        noRefreshInfo: this.get('system.upgrade_task_view_noRefresh_info'),
        /**
         * 忽略检查项
         */
        ignoreTitle: this.get('settings.upgrade_task_ignore_title'),
        /**
         * 确认忽略该检查项?
         */
        ignoreConfirm: this.get('settings.upgrade_task_ignore_info'),
        /**
         * 下次不再弹出
         */
        notPopOut: this.get('settings.upgrade_task_notPopOut_checkbox'),
        /**
         * OTA升级
         */
        otaUpgrade: this.get('settings.upgrade_task_OTAUpgrade_title'),
        // 冒号
        colon: this.get('common.colon_label'),
        /**
         * 小圆点●
         */
        circleDot: this.get('common.circleDot_icon'),
        /**
         * 升级过程中，
         */
        upgradeMsg1: this.get('system.upgrade_task_upgrading_msg1'),
        /**
         * 不推荐进行业务配置。
         */
        upgradeMsg2: this.get('system.upgrade_task_upgrading_msg2'),
        /**
         * 升级过程中，DeviceManager界面可能会自动断开，请稍后重新登录。
         */
        upgradeMsg3: this.get('system.upgrade_task_upgrading_msg3'),
        /**
         * 升级成功后，建议您先刷新页面。
         */
        upgradeMsg4: this.get('system.upgrade_task_upgrading_msg4'),

        title: {
            // 详情
            detail: this.get('system.upgrade_term_detail_checkDetail_lab'),
        },
        label: {
            // 检查项
            name: this.get('system.upgrade_term_detail_checkItem_lab'),
            // 检查方法
            method: this.get('system.upgrade_term_detail_checkWay_lab'),
            // 检查标准
            criterion: this.get('system.upgrade_term_detail_checkStandard_lab'),
            // 时间
            time: this.get('system.upgrade_term_detail_checkTime_lab'),
            // 建议
            suggestion: this.get('common.suggest_label'),
            // 检查结果
            result: this.get('system.upgrade_term_detail_checkResult_lab'),
        },
        getController: (id: string, result: string): string => this.get('system.upgrade_term_detail_controller_desc', [id, result]),
        getResultStr: (checkResult: CheckResult, isIgnoreNow: boolean): string => {
            switch (checkResult) {
                case CheckResult.Checking: return this.get('system.upgrade_term_taskStatus_checking_lab');
                case CheckResult.Fail: return this.get('system.upgrade_term_detail_checkResult_notPassed_value');
                case CheckResult.Error: return this.get('system.upgrade_term_detail_checkResult_notPassed_value');
                case CheckResult.Suc: return this.get('system.upgrade_term_detail_checkResult_passed_value');
                case CheckResult.Ignore: return isIgnoreNow ?
                    this.get('system.upgrade_term_detail_checkResult_ignoredThisTime_value') :
                    this.get('system.upgrade_term_detail_checkResult_ignored_value');
                case CheckResult.Uncheck: return this.get('system.upgrade_term_detail_checkResult_toBeCheck_value');
                default:
                    return undefined as string;
            }
        },
        evaluationVersionLab: this.get('system.upgrade_task_start_pre_evaluationVersion_lab'),
        evaluationVersionTip: this.get('system.upgrade_task_start_targetVersion_tip'),
    };

    multiUpgradeMsgs = 'multiUpgradeMsgs';

    progressDesc = {
        [Progress.prechecking]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.prechecking,
        },
        [Progress.precheckFailed]: {
            icon: Icon.failed,
            text: this.i18n.precheckFailed,
            color: Color.failed,
        },
        [Progress.precheckSuc]: {
            icon: Icon.succeed,
            text: this.i18n.precheckSuc,
            color: Color.succeed,
        },
        [Progress.upgrading]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.upgrading,
        },
        [Progress.upgradeFailed]: {
            icon: Icon.failed,
            text: this.i18n.upgradeFailed,
            color: Color.failed,
        },
        [Progress.upgradeSuc]: {
            icon: Icon.succeed,
            text: this.i18n.upgradeSuc,
            color: Color.succeed,
        },
        [Progress.verifying]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.Verifying,
        },
        [Progress.verifyFailed]: {
            icon: Icon.failed,
            text: this.i18n.verifyFailed,
            color: Color.failed,
        },
        [Progress.verifySuc]: {
            icon: Icon.succeed,
            text: this.i18n.verifySuc,
            color: Color.succeed,
        },
        [Progress.rollBacking]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.rollBacking,
        },
        [Progress.rollBackFailed]: {
            icon: Icon.failed,
            text: this.i18n.rollBackFailed,
            color: Color.failed,
        },
        [Progress.rollBackSuc]: {
            icon: Icon.succeed,
            text: this.i18n.rollBackSuc,
            color: Color.succeed,
        },
    };

    sysUpProgressDesc = {
        [Progress.checkFileUpgrading]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.checkFileUpgrading,
            color: Color.checking,
        },
        [Progress.checkFileUpgradeSuc]: {
            icon: Icon.failed,
            text: this.i18n.checkFileUpgradeSuc,
            color: Color.failed,
        },
        [Progress.checkFileUpgradeFailed]: {
            icon: Icon.succeed,
            text: this.i18n.checkFileUpgradeFailed,
            color: Color.succeed,
        },
        [Progress.evaluating]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.evaluating,
            color: Color.checking,
        },
        [Progress.evaluateFailed]: {
            icon: Icon.failed,
            text: this.i18n.evaluateFailed,
            color: Color.failed,
        },
        [Progress.evaluateSuc]: {
            icon: Icon.succeed,
            text: this.i18n.evaluateSuccess,
            color: Color.succeed,
        },
        [Progress.prechecking]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.prechecking,
            tip: this.i18n.sysPrecheckingTip,
            color: Color.checking,
        },
        [Progress.precheckFailed]: {
            icon: Icon.failed,
            text: this.i18n.precheckFailed,
            tip: this.i18n.sysPrecheckingTip,
            color: Color.failed,
        },
        [Progress.precheckSuc]: {
            icon: Icon.succeed,
            text: this.i18n.precheckSuc,
            tip: this.i18n.sysPrecheckingTip,
            color: Color.succeed,
        },
        [Progress.packageDistributWaiting]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.distributeWaiting,
            tip: this.i18n.noRefreshInfo,
            color: Color.checking,
        },
        [Progress.packageDistributing]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.distributePackage,
            tip: this.i18n.distributingInfo,
            color: Color.checking,
        },
        [Progress.packageDistributeFail]: {
            icon: Icon.failed,
            text: this.i18n.distributeFail,
            tip: this.i18n.noRefreshInfo,
            color: Color.failed,
        },
        [Progress.packageDistributeSuc]: {
            icon: Icon.succeed,
            text: this.i18n.distributeSuccess,
            tip: this.i18n.noRefreshInfo,
            color: Color.succeed,
        },
        [Progress.executeUpgradeFailed]: {
            icon: Icon.failed,
            text: this.i18n.executeUpgradeFail,
            tip: this.i18n.upgrademsg,
            color: Color.failed,
        },
        [Progress.upgrading]: {
            uploading: true,
            icon: Icon.loading,
            tip: this.multiUpgradeMsgs,
            text: this.i18n.sysUpgrading,
            color: Color.checking,
        },
        [Progress.upgradePause]: {
            icon: Icon.failed,
            tip: this.multiUpgradeMsgs,
            text: this.i18n.sysUpgradePause,
            color: Color.failed,
        },
        [Progress.upgradeFailed]: {
            icon: Icon.failed,
            text: this.i18n.sysUpgradeFail,
            color: Color.failed,
        },
        [Progress.upgradeSuc]: {
            icon: Icon.succeed,
            text: this.i18n.sysUpgradeSuc,
            color: Color.succeed,
        },
        [Progress.verifying]: {
            uploading: true,
            icon: Icon.loading,
            text: this.i18n.Verifying,
            tip: this.i18n.sysVerifyingTip,
            color: Color.checking,
        },
        [Progress.verifyFailed]: {
            icon: Icon.failed,
            text: this.i18n.verifyFailed,
            color: Color.failed,
        },
        [Progress.verifySuc]: {
            icon: Icon.succeed,
            text: this.i18n.verifySuc,
            color: Color.succeed,
        },
        [Progress.rollBacking]: {
            uploading: true,
            icon: Icon.loading,
            tip: this.multiUpgradeMsgs,
            text: this.i18n.rollBacking,
            color: Color.checking,
        },
        [Progress.rollBackFailed]: {
            icon: Icon.failed,
            text: this.i18n.rollBackFailed,
            tip: this.multiUpgradeMsgs,
            color: Color.failed,
        },
        [Progress.rollBackSuc]: {
            icon: Icon.succeed,
            text: this.i18n.rollBackSuc,
            color: Color.succeed,
        },
    };

    constructor(
        private i18nService: I18nService,
    ) { }

    getLanguage(): string {
        return this.i18nService.getLanguage();
    }

    getCheckItemValue(checkItem: string): string {
        const items = checkItem.split(':');
        if (items.length === 2) {
            return items[1];
        }
        return checkItem;
    }

    /**
     * 获取Svg图的href
     */
    getSvg(checkResult: CheckResult | string): string {
        switch (Number(checkResult)) {
            case CheckResult.Checking: return CheckResultIcon.Checking;
            case CheckResult.Fail: return CheckResultIcon.Failed;
            case CheckResult.Error: return CheckResultIcon.Failed;
            case CheckResult.Suc: return CheckResultIcon.Successed;
            case CheckResult.Ignore: return CheckResultIcon.Skipped;
            case CheckResult.Uncheck: return CheckResultIcon.NotCheck;
            default:
                return undefined as string;
        }
    }

    isCheckResultFailed = (checkResult: CheckResult): boolean => checkResult === CheckResult.Error || checkResult === CheckResult.Fail;

    ifShowSkip = (isSupportSkit: boolean, checkResult: CheckResult, currentProcess: Progress): boolean => {
        const isFailed = this.isCheckResultFailed(checkResult);
        const inProcess = [Progress.prechecking, Progress.precheckFailed, Progress.evaluating, Progress.evaluateFailed]
            .includes(currentProcess);
        return isSupportSkit && isFailed && inProcess;
    };

    /**
     * 是否显示总数
     */
    ifShowTotal(current: Progress): boolean {
        // 升级回滚阶段不显示总数
        return ![
            Progress.upgrading,
            Progress.upgradePause,
            Progress.upgradeFailed,
            Progress.upgradeSuc,
            Progress.rollBacking,
            Progress.rollBackFailed,
            Progress.rollBackPause,
            Progress.rollBackSuc,
        ].includes(current);
    }

    getErrorInfo(data: UpgradeDetail[]): string {
        if (!data) {
            return '';
        }
        const result: string[] = [];
        data.forEach((item) => {
            // 暂停或失败会显示错误详情
            if ([CmoDetailAtomState.fail, CmoDetailAtomState.pause].includes(item.CMO_DETAIL_ATOM_STATE)) {
                const errorDetail = item.CMO_DETAIL_ATOM_RECORD || this.i18n.failed;
                result.push(`${item.CMO_DETAIL_NODE_ID} - ${item.CMO_STEP_NAME} - ${errorDetail}`);
            }
        });

        return result.length ? result.join('<br>') : this.i18n.sysUploadFailedMsg;
    }

    getTargetTip(): string[] {
        const systemUpgradeUploadTargetExampleI18n = FeatureConfig.SystemUpgradeUploadTargetExampleI18n;

        // 配置文件读取值Xseries，micro
        if (systemUpgradeUploadTargetExampleI18n) {
            return [this.get(`system.upgrade_task_start_targetVersion_example_${systemUpgradeUploadTargetExampleI18n}`)];
        }

        return [
            this.get('system.upgrade_task_start_targetVersion_example_dorado'),
            this.get('system.upgrade_task_start_targetVersion_example2_dorado'),
        ];
    }
}
